// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-datepicker {
  overflow: hidden;
}

.react-datepicker-popper[data-placement^='bottom']
  .react-datepicker__triangle::before,
.react-datepicker-popper[data-placement^='top']
  .react-datepicker__triangle::before,
.react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before {
  border-bottom: none;
}

.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle,
.react-datepicker-popper[data-placement^='bottom']
  .react-datepicker__triangle::before {
  border-bottom-color: #fff;
}

.react-datepicker-popper[data-placement^='bottom']
  .react-datepicker__triangle::before {
  border: none;
  box-shadow: 0 2px 8px rgb(0 0 0 / 30%);
}

.react-datepicker-popper[data-placement^='top']
  .react-datepicker__triangle::before,
.react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before {
  border-top-color: #cbd5e1;
}

.react-datepicker {
  font-family: Gudea, ui-sans-serif, system-ui;
  color: #0f172a;
  border: none;
  box-shadow: 0 2px 8px rgb(0 0 0 / 30%);
}

.react-datepicker__header {
  background-color: #fff;
  border: none;
}

.react-datepicker__header--time {
  background-color: #f8fafc;
  border-bottom: 1px solid #cbd5e1;
  border-top-left-radius: 0;
}

.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header {
  color: #475569;
}

.react-datepicker__navigation--previous {
  border-right-color: #94a3b8;
}

.react-datepicker__navigation--previous:hover {
  border-right-color: #475569;
}

.react-datepicker__navigation--next {
  border-left-color: #94a3b8;
}

.react-datepicker__navigation--next--with-time:not(
    .react-datepicker__navigation--next--with-today-button
  ) {
  right: 90px;
}

.react-datepicker__navigation--next:hover {
  border-left-color: #475569;
}

.react-datepicker__navigation--years-previous {
  border-top-color: #94a3b8;
}

.react-datepicker__navigation--years-previous:hover {
  border-top-color: #475569;
}

.react-datepicker__navigation--years-upcoming {
  border-bottom-color: #94a3b8;
}

.react-datepicker__navigation--years-upcoming:hover {
  border-bottom-color: #475569;
}

.react-datepicker__time-container {
  border-left: 1px solid #cbd5e1;
}

.react-datepicker__time-container--with-today-button {
  border: 1px solid #cbd5e1;
}

.react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list
  li.react-datepicker__time-list-item {
  padding: 7px 10px;
}

.react-datepicker__time,
.react-datepicker__time ul {
  height: 173px !important;
}

.react-datepicker__time-box {
  height: 173px;
}

.react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list
  li.react-datepicker__time-list-item:hover {
  background-color: #e2e8f0;
}

.react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list
  li.react-datepicker__time-list-item--selected {
  background-color: #f59e0b;
  border-radius: 4px;
}

.react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list
  li.react-datepicker__time-list-item--selected:hover {
  background-color: #f59e0b;
}

.react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list
  li.react-datepicker__time-list-item--disabled {
  color: #94a3b8;
}

.react-datepicker__week-number {
  color: #94a3b8;
}

.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {
  background-color: #fff;
}

.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
  color: #0f172a;
}

.react-datepicker__month--selected,
.react-datepicker__month--in-selecting-range,
.react-datepicker__month--in-range,
.react-datepicker__quarter--selected,
.react-datepicker__quarter--in-selecting-range,
.react-datepicker__quarter--in-range {
  background-color: #f59e0b;
}

.react-datepicker__month--selected:hover,
.react-datepicker__month--in-selecting-range:hover,
.react-datepicker__month--in-range:hover,
.react-datepicker__quarter--selected:hover,
.react-datepicker__quarter--in-selecting-range:hover,
.react-datepicker__quarter--in-range:hover {
  background-color: #d97706;
}

.react-datepicker__month--disabled,
.react-datepicker__quarter--disabled {
  color: #94a3b8;
}

.react-datepicker__day:hover,
.react-datepicker__month-text:hover,
.react-datepicker__quarter-text:hover {
  background-color: #e2e8f0;
}

.react-datepicker__day--selected,
.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--selected,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__quarter-text--in-range {
  background-color: #f59e0b;
  color: #fff;
  font-weight: bold;
}

.react-datepicker__day--selected:hover,
.react-datepicker__day--in-selecting-range:hover,
.react-datepicker__day--in-range:hover,
.react-datepicker__month-text--selected:hover,
.react-datepicker__month-text--in-selecting-range:hover,
.react-datepicker__month-text--in-range:hover,
.react-datepicker__quarter-text--selected:hover,
.react-datepicker__quarter-text--in-selecting-range:hover,
.react-datepicker__quarter-text--in-range:hover {
  background-color: #f59e0b;
}

.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected {
  background-color: #fbbf24;
}

.react-datepicker__day--keyboard-selected:hover,
.react-datepicker__month-text--keyboard-selected:hover,
.react-datepicker__quarter-text--keyboard-selected:hover {
  background-color: #d97706;
}

.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range {
  background-color: #d97706;
}

.react-datepicker__month--selecting-range .react-datepicker__day--in-range,
.react-datepicker__month--selecting-range
  .react-datepicker__month-text--in-range,
.react-datepicker__month--selecting-range
  .react-datepicker__quarter-text--in-range {
  background-color: #fff;
  color: #475569;
}

.react-datepicker__day--disabled,
.react-datepicker__month-text--disabled,
.react-datepicker__quarter-text--disabled {
  color: #94a3b8;
}

.react-datepicker__month-text.react-datepicker__month--selected:hover,
.react-datepicker__month-text.react-datepicker__month--in-range:hover,
.react-datepicker__month-text.react-datepicker__quarter--selected:hover,
.react-datepicker__month-text.react-datepicker__quarter--in-range:hover,
.react-datepicker__quarter-text.react-datepicker__month--selected:hover,
.react-datepicker__quarter-text.react-datepicker__month--in-range:hover,
.react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,
.react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {
  background-color: #f59e0b;
}

.react-datepicker__month-text:hover,
.react-datepicker__quarter-text:hover {
  background-color: #e2e8f0;
}

.react-datepicker__year-read-view:hover
  .react-datepicker__year-read-view--down-arrow,
.react-datepicker__year-read-view:hover
  .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-read-view:hover
  .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view:hover
  .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover
  .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover
  .react-datepicker__month-read-view--down-arrow {
  border-top-color: #475569;
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
  border-top-color: #94a3b8;
}

.react-datepicker__year-dropdown,
.react-datepicker__month-dropdown,
.react-datepicker__month-year-dropdown {
  background-color: #fff;
  border: 1px solid #cbd5e1;
}

.react-datepicker__year-option:hover,
.react-datepicker__month-option:hover,
.react-datepicker__month-year-option:hover {
  background-color: #94a3b8;
}

.react-datepicker__year-option:hover
  .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-option:hover
  .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-year-option:hover
  .react-datepicker__navigation--years-upcoming {
  border-bottom-color: #475569;
}

.react-datepicker__year-option:hover
  .react-datepicker__navigation--years-previous,
.react-datepicker__month-option:hover
  .react-datepicker__navigation--years-previous,
.react-datepicker__month-year-option:hover
  .react-datepicker__navigation--years-previous {
  border-top-color: #475569;
}

.react-datepicker__close-icon::after {
  background-color: #f59e0b;
}

.react-datepicker__today-button {
  background: #fff;
  border-top: 1px solid #cbd5e1;
}

.react-datepicker__portal .react-datepicker__navigation--previous {
  border-right-color: #94a3b8;
}

.react-datepicker__portal .react-datepicker__navigation--previous:hover {
  border-right-color: #475569;
}

.react-datepicker__portal .react-datepicker__navigation--next {
  border-left-color: #94a3b8;
}

.react-datepicker__portal .react-datepicker__navigation--next:hover {
  border-left-color: #475569;
}
`, "",{"version":3,"sources":["webpack://./../../libs/console/legacy-ce/src/lib/features/InsertRow/components/date-input.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,mBAAmB;AACrB;;AAEA;;;EAGE,yBAAwC;AAC1C;;AAEA;;EAEE,YAAY;EACZ,sCAAsC;AACxC;;AAEA;;;;;EAKE,yBAAyC;AAC3C;;AAEA;EACE,4CAAmC;EACnC,cAA8B;EAC9B,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,sBAAqC;EACrC,YAAY;AACd;;AAEA;EACE,yBAAwC;EACxC,gCAAgD;EAChD,yBAAyB;AAC3B;;AAEA;;;EAGE,cAA8B;AAChC;;AAEA;EACE,2BAA2C;AAC7C;;AAEA;EACE,2BAA2C;AAC7C;;AAEA;EACE,0BAA0C;AAC5C;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,0BAA0C;AAC5C;;AAEA;EACE,yBAAyC;AAC3C;;AAEA;EACE,yBAAyC;AAC3C;;AAEA;EACE,4BAA4C;AAC9C;;AAEA;EACE,4BAA4C;AAC9C;;AAEA;EACE,8BAA8C;AAChD;;AAEA;EACE,yBAAyC;AAC3C;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;EAKE,yBAAyC;AAC3C;;AAEA;;;;;EAKE,yBAAyC;EACzC,kBAAkB;AACpB;;AAEA;;;;;EAKE,yBAAyC;AAC3C;;AAEA;;;;;EAKE,cAA8B;AAChC;;AAEA;EACE,cAA8B;AAChC;;AAEA;EACE,sBAAqC;AACvC;;AAEA;;;EAGE,cAA8B;AAChC;;AAEA;;;;;;EAME,yBAAyC;AAC3C;;AAEA;;;;;;EAME,yBAAyC;AAC3C;;AAEA;;EAEE,cAA8B;AAChC;;AAEA;;;EAGE,yBAAyC;AAC3C;;AAEA;;;;;;;;;EASE,yBAAyC;EACzC,WAAW;EACX,iBAAiB;AACnB;;AAEA;;;;;;;;;EASE,yBAAyC;AAC3C;;AAEA;;;EAGE,yBAAyC;AAC3C;;AAEA;;;EAGE,yBAAyC;AAC3C;;AAEA;;;EAGE,yBAAyC;AAC3C;;AAEA;;;;;EAKE,sBAAqC;EACrC,cAA8B;AAChC;;AAEA;;;EAGE,cAA8B;AAChC;;AAEA;;;;;;;;EAQE,yBAAyC;AAC3C;;AAEA;;EAEE,yBAAyC;AAC3C;;AAEA;;;;;;;;;;;;EAYE,yBAAyC;AAC3C;;AAEA;;;EAGE,yBAAyC;AAC3C;;AAEA;;;EAGE,sBAAqC;EACrC,yBAAyC;AAC3C;;AAEA;;;EAGE,yBAAyC;AAC3C;;AAEA;;;;;;EAME,4BAA4C;AAC9C;;AAEA;;;;;;EAME,yBAAyC;AAC3C;;AAEA;EACE,yBAAyC;AAC3C;;AAEA;EACE,gBAA+B;EAC/B,6BAA6C;AAC/C;;AAEA;EACE,2BAA2C;AAC7C;;AAEA;EACE,2BAA2C;AAC7C;;AAEA;EACE,0BAA0C;AAC5C;;AAEA;EACE,0BAA0C;AAC5C","sourcesContent":[".react-datepicker {\n  overflow: hidden;\n}\n\n.react-datepicker-popper[data-placement^='bottom']\n  .react-datepicker__triangle::before,\n.react-datepicker-popper[data-placement^='top']\n  .react-datepicker__triangle::before,\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  border-bottom: none;\n}\n\n.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle,\n.react-datepicker-popper[data-placement^='bottom']\n  .react-datepicker__triangle::before {\n  border-bottom-color: theme(colors.white);\n}\n\n.react-datepicker-popper[data-placement^='bottom']\n  .react-datepicker__triangle::before {\n  border: none;\n  box-shadow: 0 2px 8px rgb(0 0 0 / 30%);\n}\n\n.react-datepicker-popper[data-placement^='top']\n  .react-datepicker__triangle::before,\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  border-top-color: theme(colors.slate.300);\n}\n\n.react-datepicker {\n  font-family: theme(fontFamily.sans);\n  color: theme(colors.slate.900);\n  border: none;\n  box-shadow: 0 2px 8px rgb(0 0 0 / 30%);\n}\n\n.react-datepicker__header {\n  background-color: theme(colors.white);\n  border: none;\n}\n\n.react-datepicker__header--time {\n  background-color: theme(colors.slate.50);\n  border-bottom: 1px solid theme(colors.slate.300);\n  border-top-left-radius: 0;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  color: theme(colors.slate.600);\n}\n\n.react-datepicker__navigation--previous {\n  border-right-color: theme(colors.slate.400);\n}\n\n.react-datepicker__navigation--previous:hover {\n  border-right-color: theme(colors.slate.600);\n}\n\n.react-datepicker__navigation--next {\n  border-left-color: theme(colors.slate.400);\n}\n\n.react-datepicker__navigation--next--with-time:not(\n    .react-datepicker__navigation--next--with-today-button\n  ) {\n  right: 90px;\n}\n\n.react-datepicker__navigation--next:hover {\n  border-left-color: theme(colors.slate.600);\n}\n\n.react-datepicker__navigation--years-previous {\n  border-top-color: theme(colors.slate.400);\n}\n\n.react-datepicker__navigation--years-previous:hover {\n  border-top-color: theme(colors.slate.600);\n}\n\n.react-datepicker__navigation--years-upcoming {\n  border-bottom-color: theme(colors.slate.400);\n}\n\n.react-datepicker__navigation--years-upcoming:hover {\n  border-bottom-color: theme(colors.slate.600);\n}\n\n.react-datepicker__time-container {\n  border-left: 1px solid theme(colors.slate.300);\n}\n\n.react-datepicker__time-container--with-today-button {\n  border: 1px solid theme(colors.slate.300);\n}\n\n.react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box\n  ul.react-datepicker__time-list\n  li.react-datepicker__time-list-item {\n  padding: 7px 10px;\n}\n\n.react-datepicker__time,\n.react-datepicker__time ul {\n  height: 173px !important;\n}\n\n.react-datepicker__time-box {\n  height: 173px;\n}\n\n.react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box\n  ul.react-datepicker__time-list\n  li.react-datepicker__time-list-item:hover {\n  background-color: theme(colors.slate.200);\n}\n\n.react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box\n  ul.react-datepicker__time-list\n  li.react-datepicker__time-list-item--selected {\n  background-color: theme(colors.amber.500);\n  border-radius: 4px;\n}\n\n.react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box\n  ul.react-datepicker__time-list\n  li.react-datepicker__time-list-item--selected:hover {\n  background-color: theme(colors.amber.500);\n}\n\n.react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box\n  ul.react-datepicker__time-list\n  li.react-datepicker__time-list-item--disabled {\n  color: theme(colors.slate.400);\n}\n\n.react-datepicker__week-number {\n  color: theme(colors.slate.400);\n}\n\n.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {\n  background-color: theme(colors.white);\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  color: theme(colors.slate.900);\n}\n\n.react-datepicker__month--selected,\n.react-datepicker__month--in-selecting-range,\n.react-datepicker__month--in-range,\n.react-datepicker__quarter--selected,\n.react-datepicker__quarter--in-selecting-range,\n.react-datepicker__quarter--in-range {\n  background-color: theme(colors.amber.500);\n}\n\n.react-datepicker__month--selected:hover,\n.react-datepicker__month--in-selecting-range:hover,\n.react-datepicker__month--in-range:hover,\n.react-datepicker__quarter--selected:hover,\n.react-datepicker__quarter--in-selecting-range:hover,\n.react-datepicker__quarter--in-range:hover {\n  background-color: theme(colors.amber.600);\n}\n\n.react-datepicker__month--disabled,\n.react-datepicker__quarter--disabled {\n  color: theme(colors.slate.400);\n}\n\n.react-datepicker__day:hover,\n.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover {\n  background-color: theme(colors.slate.200);\n}\n\n.react-datepicker__day--selected,\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range {\n  background-color: theme(colors.amber.500);\n  color: #fff;\n  font-weight: bold;\n}\n\n.react-datepicker__day--selected:hover,\n.react-datepicker__day--in-selecting-range:hover,\n.react-datepicker__day--in-range:hover,\n.react-datepicker__month-text--selected:hover,\n.react-datepicker__month-text--in-selecting-range:hover,\n.react-datepicker__month-text--in-range:hover,\n.react-datepicker__quarter-text--selected:hover,\n.react-datepicker__quarter-text--in-selecting-range:hover,\n.react-datepicker__quarter-text--in-range:hover {\n  background-color: theme(colors.amber.500);\n}\n\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected {\n  background-color: theme(colors.amber.400);\n}\n\n.react-datepicker__day--keyboard-selected:hover,\n.react-datepicker__month-text--keyboard-selected:hover,\n.react-datepicker__quarter-text--keyboard-selected:hover {\n  background-color: theme(colors.amber.600);\n}\n\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range {\n  background-color: theme(colors.amber.600);\n}\n\n.react-datepicker__month--selecting-range .react-datepicker__day--in-range,\n.react-datepicker__month--selecting-range\n  .react-datepicker__month-text--in-range,\n.react-datepicker__month--selecting-range\n  .react-datepicker__quarter-text--in-range {\n  background-color: theme(colors.white);\n  color: theme(colors.slate.600);\n}\n\n.react-datepicker__day--disabled,\n.react-datepicker__month-text--disabled,\n.react-datepicker__quarter-text--disabled {\n  color: theme(colors.slate.400);\n}\n\n.react-datepicker__month-text.react-datepicker__month--selected:hover,\n.react-datepicker__month-text.react-datepicker__month--in-range:hover,\n.react-datepicker__month-text.react-datepicker__quarter--selected:hover,\n.react-datepicker__month-text.react-datepicker__quarter--in-range:hover,\n.react-datepicker__quarter-text.react-datepicker__month--selected:hover,\n.react-datepicker__quarter-text.react-datepicker__month--in-range:hover,\n.react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,\n.react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {\n  background-color: theme(colors.amber.500);\n}\n\n.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover {\n  background-color: theme(colors.slate.200);\n}\n\n.react-datepicker__year-read-view:hover\n  .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__year-read-view:hover\n  .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-read-view:hover\n  .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view:hover\n  .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover\n  .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover\n  .react-datepicker__month-read-view--down-arrow {\n  border-top-color: theme(colors.slate.600);\n}\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  border-top-color: theme(colors.slate.400);\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n  background-color: theme(colors.white);\n  border: 1px solid theme(colors.slate.300);\n}\n\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n  background-color: theme(colors.slate.400);\n}\n\n.react-datepicker__year-option:hover\n  .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-option:hover\n  .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-year-option:hover\n  .react-datepicker__navigation--years-upcoming {\n  border-bottom-color: theme(colors.slate.600);\n}\n\n.react-datepicker__year-option:hover\n  .react-datepicker__navigation--years-previous,\n.react-datepicker__month-option:hover\n  .react-datepicker__navigation--years-previous,\n.react-datepicker__month-year-option:hover\n  .react-datepicker__navigation--years-previous {\n  border-top-color: theme(colors.slate.600);\n}\n\n.react-datepicker__close-icon::after {\n  background-color: theme(colors.amber.500);\n}\n\n.react-datepicker__today-button {\n  background: theme(colors.white);\n  border-top: 1px solid theme(colors.slate.300);\n}\n\n.react-datepicker__portal .react-datepicker__navigation--previous {\n  border-right-color: theme(colors.slate.400);\n}\n\n.react-datepicker__portal .react-datepicker__navigation--previous:hover {\n  border-right-color: theme(colors.slate.600);\n}\n\n.react-datepicker__portal .react-datepicker__navigation--next {\n  border-left-color: theme(colors.slate.400);\n}\n\n.react-datepicker__portal .react-datepicker__navigation--next:hover {\n  border-left-color: theme(colors.slate.600);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
